module.exports = __webpack_public_path__ + "static/media/sparkling.c3335051.png";